import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import CloseIcon from '@src/componentsNew/Icons/Icons/CloseIcon';

import './mobile-product-list-filter-style.scss';

import Chip from '@src/componentsNew/Chip';
import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

import useIsComDomain from '@src/hooks/useIsComDomain';

import { productsVariables } from '@components/ProductPage/ProductList/__generated__/products';
import { StockAvailability } from '__generated__/globalTypes';
import { MOBILE_PRODUCTS_FILTER_OPTIONS, COM_MOBILE_PRODUCTS_FILTER_OPTIONS } from '@src/utils/constants';

interface IProps {
  open: boolean;
  onClose?: any;
  variables: productsVariables;
  setVariables: any;
}

const MobileProductListFilter = ({ open, onClose, variables, setVariables }: IProps) => {
  const isComDomain = useIsComDomain();

  // 현재 선택 중인 Filter Option
  const [currentSelectedOption, setCurrentSelectedOption] = useState(MOBILE_PRODUCTS_FILTER_OPTIONS[0]);
  // Filter Option의 선택된 하위 Item
  const [selectedSubOptionItems, setSelectedSubOptionItems] = useState<productsVariables>({
    stockAvailability: variables?.stockAvailability,
  });

  useEffect(() => {
    // variables에 isMgs값이 boolean type일 경우, selectedSubOptionItems에 추가
    if (typeof variables?.isMgs === 'boolean') {
      setSelectedSubOptionItems((prev) => ({
        ...prev,
        isMgs: variables.isMgs,
      }));
    }
  }, []);

  const handleClickOptionItem = (optionName, value) => {
    setSelectedSubOptionItems((prev) => ({
      ...prev,
      [optionName]: value,
    }));
  };

  const handleClickReset = () => {
    setVariables((prev) => {
      const updatedVariables = { ...prev };

      if ('isMgs' in updatedVariables) {
        delete updatedVariables['isMgs'];
      }
      updatedVariables['stockAvailability'] = StockAvailability.IN_STOCK;

      return updatedVariables;
    });

    onClose();
  };

  const handleClickShowResult = () => {
    setVariables((prev) => {
      const updatedVariables = { ...prev, ...selectedSubOptionItems };

      if (typeof updatedVariables?.isMgs !== 'boolean') {
        delete updatedVariables['isMgs'];
      }

      return updatedVariables;
    });

    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} onClick={(e) => e.stopPropagation()}>
      <div className="mobile-product-list-filter-content">
        <CloseIcon cName="close-btn" onClick={onClose} />

        <div className="filter-option-area">
          {(isComDomain ? COM_MOBILE_PRODUCTS_FILTER_OPTIONS : MOBILE_PRODUCTS_FILTER_OPTIONS).map((option, idx) => (
            <Chip
              key={idx}
              className={`filter-option ${currentSelectedOption.title === option.title ? 'selected' : ''}`}
              name={
                <>
                  <Typography variant="body3" component="span">
                    {`${option.title} | `}
                  </Typography>
                  <Typography variant="subtitle2" component="span">
                    {option.name in selectedSubOptionItems
                      ? option.options.find((o) => o.value === selectedSubOptionItems[option.name])?.title
                      : 'All'}
                  </Typography>
                </>
              }
              onClick={() => setCurrentSelectedOption(option)}
            />
          ))}
        </div>

        <div className="filter-option-item-wrapper">
          {currentSelectedOption?.options.map((option, idx) => (
            <Typography
              key={idx}
              cName="filter-option-item"
              variant="body3"
              component="span"
              onClick={() => handleClickOptionItem(currentSelectedOption.name, option.value)}
              style={{ color: '#212121' }}
            >
              {option.title}
            </Typography>
          ))}
        </div>

        <div className="action-btn-wrapper">
          <Button cName="reset-btn" variant="contained" size="medium" onClick={handleClickReset}>
            Reset
          </Button>
          <Button cName="action-btn" variant="contained" size="medium" onClick={handleClickShowResult}>
            Show Result
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MobileProductListFilter;
